// One entry per audience, each pointing at ITS OWN backend endpoint.
//
// The bug this replaces: a single `/forgot-pass` route rendered the STUDENT reset page, and the
// applicant, faculty, examiner and admin login screens all linked to it. Every non-student had
// their address looked up in the `students` collection, found nothing, and got the endpoint's
// deliberately generic "New password sent to your email." — a silent failure that looked like
// success. Adding an audience here means adding a route in App.js and linking to its `path`.

import {
  forgotPassAPI,
  forgotStudentPassAPI,
  facultyForgotPassAPI,
  nonTeachingStaffForgotPassAPI,
  examinerForgotPassAPI,
  forgotAdminPassAPI,
} from "../../utils/Api";

export const FORGOT_PASSWORD_AUDIENCES = {
  student: {
    key: "student",
    path: "/forgot-pass",
    title: "Student Password Reset",
    subtitle: "Enter the email address registered with the college.",
    loginPath: "/student/login",
    loginLabel: "Back to student login",
    submit: forgotStudentPassAPI,
  },
  user: {
    key: "user",
    path: "/user/forgot-pass",
    title: "Applicant Password Reset",
    subtitle: "Enter the email address you used to register your application.",
    loginPath: "/",
    loginLabel: "Back to login",
    submit: forgotPassAPI,
  },
  faculty: {
    key: "faculty",
    path: "/faculty/forgot-pass",
    title: "Faculty Password Reset",
    subtitle: "Enter your college email address.",
    loginPath: "/faculty/login",
    loginLabel: "Back to faculty login",
    submit: facultyForgotPassAPI,
  },
  nonTeachingStaff: {
    key: "nonTeachingStaff",
    path: "/non-teaching-staff/forgot-password",
    title: "Staff Password Reset",
    subtitle: "Enter your college email address.",
    loginPath: "/non-teaching-staff/login",
    loginLabel: "Back to staff login",
    submit: nonTeachingStaffForgotPassAPI,
  },
  examiner: {
    key: "examiner",
    path: "/examiner/forgot-pass",
    title: "Examiner Password Reset",
    subtitle: "Enter the email address registered for examiner access.",
    loginPath: "/examiner/login",
    loginLabel: "Back to examiner login",
    submit: examinerForgotPassAPI,
  },
  admin: {
    key: "admin",
    path: "/admin/forgot-pass",
    title: "Admin Password Reset",
    subtitle: "Enter your administrator email address.",
    loginPath: "/",
    loginLabel: "Back to login",
    submit: forgotAdminPassAPI,
  },
};
